<template>
  <div class="wrapper" v-if="showPage">
    <div class="wrapper_main">
      <!-- 状态显示 -->
      <!-- 已支付 -->
      <img class="img_status" v-if="status==2" src="../../assets/images/icon_audit_pay.png" alt="">
      <!-- 已关闭 -->
      <img class="img_status" v-if="status!=2 && status != 0" src="../../assets/images/icon_audit_closed.png" alt="">
      <section class="title_box">
        <section class="title_box_top">
          <img src="../../assets/images/icon_approve_goods.png" />
          <h2>办公耗材订单详情</h2>
        </section>
        <p class="title_date">{{orderInfo.createTime}}</p>
      </section>
      <div class="click_item">
        <img class="click_image" :src="orderInfo.imgUrl">
        <div class="click_info">
          <p class="click_title">{{orderInfo.materialName}}</p>
          <p :class="['label_s',orderInfo.serviceType==0?'':'more_time']">{{orderInfo.serviceType | serviceType}}</p>
          <p class="click_num">x{{orderInfo.orderNum}}</p>
          <p class="click_price">¥{{orderInfo.price | priceFormat}}</p>
        </div>
      </div>
      <div class="orderCard">
        <div class="orderNubBox">
          <span class="orderNubTitle">预订人</span>
          <span class="orderNub">{{orderInfo.createName}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">企业名称</span>
          <span class="orderNub">{{orderInfo.companyName}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">联系电话</span>
          <span class="orderNub">{{orderInfo.phone}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">订单编号</span>
          <span class="orderNub">{{orderInfo.orderNo}}</span>
        </div>
        <div class="orderNubBox order_time" v-if="orderInfo.createTime">
          <span class="orderNubTitle">下单时间</span>
          <span class="orderNub">{{orderInfo.createTime}}</span>
        </div>
        <div class="orderNubBox" v-if="orderInfo.payTime && status == 2">
          <span class="orderNubTitle">支付时间</span>
          <span class="orderNub">{{orderInfo.payTime}}</span>
        </div>
      </div>
      <div class="orderCard border-top price_box">
        <div class="orderNubBox">
          <span class="orderNubTitle">单价</span>
          <span class="orderNub">¥{{orderInfo.price | priceFormat}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">数量</span>
          <span class="orderNub">x{{orderInfo.orderNum}}</span>
        </div>
        <div class="orderNubBox order_time">
          <span class="orderNubTitle">{{status==2?'实付金额':'应付金额'}}</span>
          <span class="orderNub payAmount">￥{{orderInfo.payAmount|priceFormat}}</span>
        </div>
      </div>
    </div>
    <section class="footer_btn button" v-if="status == 0">
      <span class="btn_left btn_primary" @click="closeOrder">关闭订单</span>
      <span class="btn_right btn_default" @click="surePayOrder">确认已支付</span>
    </section>
  </div>
</template>

<script>
import util from "../../utils/util";
import {getOfficeMaterialOrderDetailById, officeupdateOrderStatusWeChat} from "../../utils/api";
import { mapState } from "vuex";
export default {
  name: "exchangeOrderDetail",
  props: {},
  filters: {
    serviceType(val){
      if(val == '0'){
        return '一次性送货'
      }else{
        return '多次送货服务'
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      id: "",
      orderInfo: {},
      status:'',//支付状态，0待支付，1已取消，2已支付，3已超时，4已退款，5已完成
      couponPrice:0,
      showPage:false
    }
  },
  activated() {
    console.log(this.$store)
    this.id = this.$route.query.id;
    util.showLoading()
    this.getOfficeMaterialOrderDetailById();
  },
  methods: {
      getOfficeMaterialOrderDetailById(){
        util.showLoading()
        getOfficeMaterialOrderDetailById({orderId: this.$route.query.id}).then(res => {
          console.log(res)
          util.hideLoading()
          if (res.res && res.res.code === 10000 && res.body) {
            this.orderInfo = res.body.order || {};
            this.status = res.body.order.status;
            this.deliveryList = res.body.deliveryList || [];
          } else {
            util.showToast(res.res.msg);
          }
          this.showPage = true;
        })
    },
    closeOrder(){
      util.showModal('','确定要关闭该订单吗?',true,'确定',()=>{
        this.officeupdateOrderStatusWeChat('1')
      })
    },
    surePayOrder(){
      util.showModal('','确定该订单已支付?',true,'确定',()=>{
        this.officeupdateOrderStatusWeChat('2')
      })
    },
    officeupdateOrderStatusWeChat(status){
      util.showLoading()
      officeupdateOrderStatusWeChat({
          orderId: this.$route.query.id,
          status:status,//0待支付，1已取消，2已支付
          approve:this.common.userInfo.account || this.common.userInfo.phone
        }).then(res => {
          console.log(res)
          if (res.res && res.res.code === 10000) {
            this.getOfficeMaterialOrderDetailById()
          }else{
            util.showToast(res.res.msg)
          }
        })
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
  background-color: rgba(243, 244, 246, 1);
}
.wrapper_main {
  margin: 20px 20px 120px;
  background: #fff;
  border-radius: 8px;
  padding: 0 40px;
  position:relative;
}
.img_status{
  display:block;
  position:absolute;
  top:40px;right:40px;
  width:120px;height:120px;
  z-index:2;
}
.title_box {
  padding: 40px 0 28px 0;
  .title_box_top {
    .flex();
    margin-bottom: 20px;
    img {
      width: 44px;
      height: 44px;
      display: block;
      margin-right: 20px;
    }
    h2 {
      font-weight: bold;
      font-size: 32px;
      color: rgba(51, 51, 51, 1);
      line-height: 44px;
    }
  }
  .title_date {
    font-size: 24px;
    color: rgba(153, 153, 153, 1);
    line-height: 34px;
  }
}
/*item 样式*/
 .click_item{
    .flex();
    padding: 28px 0;
    opacity: 1;
    background-color: #ffffff;
    margin-bottom:14px;
  }
  .click_desc{
    .fontSize(12px);
    color:@color6;
    line-height:34px;
    margin-bottom: 8px;
  }
  .click_image{
    display: block;
    width: 240px;
    height: 180px;
    margin-right: 20px;
  }
  .click_info{
    flex:1;
  }
  .click_title{
    height:40px;
    .fontSize(14px);
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:40px;
    .textOver(100%);
    margin-bottom: 20px;
  }
  .click_label{
    line-height:36px;
    background:rgba(255,240,225,1);
    border-radius:4px;
    font-size:24px;
    color:rgba(255,126,30,1);
    display: inline-block;
    padding:0 6px;
  }
  .label_s{
    padding:0 6px;
    height:36px;
    background:rgba(255,240,225,1);
    border-radius:4px;
    font-size:24px;
    margin-bottom:10px;
    color:rgba(255,126,30,1);
    line-height:36px;
    display: inline-block;
  }
  .more_time{
    background:#def5ed;
    color:#16bc84;
  }
  .click_num{
    font-size:26px;
    color:rgba(153,153,153,1);
    line-height:36px;
    // text-align: right;
    margin-bottom:4px;
  }
  .click_price{
    font-size:28px;
    color:rgba(51,51,51,1);
    line-height:40px;
    // text-align: right;
  }

/*-----------中间卡片信息模块------*/

.card_box {
  position: relative;
  width: 690px;
  margin-left: 30px;
  margin-top: 26px;
}

.card_title {
  .fontSize(14px);
  font-weight: bold;
  color: rgba(254, 254, 254, 1);
  line-height: 36px;
  position: absolute;
  left: 28px;
  top: 30px;
  right: 28px;
}

.pay_time {
  .fontSize(12px);
  color: rgba(254, 254, 254, 1);
}

.card_address {
  .fontSize(12px);
  color: rgba(254, 254, 254, 1);
  position: absolute;
  left: 28px;
  top: 116px;
  right: 28px;
}

.card_price_box {
  flex-direction: row;
  position: absolute;
  left: 28px;
  right: 28px;
  bottom: 124px;
}

.card_price {
  color: #fff;
  .fontSize(18px);
  line-height: 36px;
}

.card_num {
  color: #fff;
  .fontSize(12px);
  line-height: 36px;
  margin-top: 4px;
}

.card_time_box {
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  height: 102px;
  align-items: center;
  left: 28px;
  right: 28px;
  bottom: 0;
}

.activity_time {
  color: #fff;
  .fontSize(12px);
}

/*----------中间用户信息模块-------*/
.refundBox {
  background-color: rgba(255, 255, 255, 1);
  padding: 28px;
}

.refundText {
  height: 44px;
  .fontSize(16px);
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  margin-bottom: 20px;
  padding-left: 18px;
  position: relative;
  &::after {
    position: absolute;
    content: "";
    left: 0;
    top: 4px;
    width: 6px;
    height: 24px;
    background: @color17;
  }
}

.refundMainBox {
  .flex();
  margin-top: 18px;
  width: 710px;
}

.refundMainLeft {
  width: 72px;
  .flex(column);
  justify-content: space-around;
  align-items: center;
}

.refundMainRight {
  flex: 1;
  height: 34px;
  .flex(column);
  justify-content: space-between;
}
.refundMainRight_upt {
  height: 128px;
}
.refundMainRight_succ {
  height: 220px;
}

.refundMainText {
  .fontSize(12px);
  /*color: rgba(51, 51, 51, 1);*/
  line-height: 34px;
}
.refund_active {
  color: #333333;
}
.refund_default {
  color: #dadada;
}

.circle {
  width: 20px;
  height: 20px;
  background-color: @color17;
  border: 4px solid rgba(255, 255, 255, 1);
  border-radius: 100%;
  // margin: 7px 0;
}

.upright {
  width: 4px;
  height: 60px;
  /*background-color: @color17;*/
}
.active_color {
  background-color: @color17;
}
.default_color {
  background-color: #dadada;
}

/*----------中间用户信息模块-------*/

.copy {
  width: 96px;
  height: 40px;
  border-radius: 4px;
  .border();
  .fontSize(12px);
  color: @color3;
  line-height: 40px;
  text-align: center;
  margin-left: 28px;
}

.mainCard {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  /*box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);*/
  /*border-radius: 16px;*/
  margin-bottom: 14px;
}

.QRCodeCard {
  .flex(column);
  align-items: center;
  width: 100%;
}
.QRCodeTitle {
  .fontSize(14px);
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 40px;
}

.QRCode {
  width: 260px;
  height: 260px;
  /*margin: 20px 0;*/
}

.QRCodeOrderNo {
  .fontSize(14px);
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-bottom: 40px;
}

.orderCard {
  overflow:hidden;
}
.price_box{
  padding-top:14px;
}
.createTimeBox {
  border-top: 2px solid rgba(234, 234, 234, 1);
  padding: 0 20px 28px;
}

.orderTitle {
  height: 28px;
  .fontSize(14px);
  font-weight: bold;
  color: @color3;
  line-height: 28px;
  border-left: 4px solid @color17;
  margin-top: 6px;
  margin-bottom: 20px;
  padding-left: 14px;
}

.orderNubBox {
  width:100%;
  margin-bottom: 14px;
  .flex();
  justify-content: space-between;
}
.order_time{
  margin-bottom:14px;
}
.all_time{
  padding-top:28px;
}

.orderNubTitle {
  .fontSize(12px);
  color: @color6;
  line-height: 40px;
}

.orderNub {
  .fontSize(12px);
  color: @color3;
  line-height: 40px;
  flex:1;
  text-align:right;
}

.customer_box {
  padding-top: 20px;
  border-bottom: 10px solid #f3f4f6;
}

.customer_box_list {
  flex-direction: row;
  justify-content: space-between;
  .borderT();
  padding-left: 30px;
  padding-right: 30px;
}

.list_key {
  height: 100px;
  line-height: 100px;
  .fontSize(14px);
  color: #999;
}

.list_val {
  height: 100px;
  line-height: 100px;
  .fontSize(14px);
  color: #333;
}

/*----------中间支付选择模块-------*/

.butn_img {
  position: relative;
  top: -1px;
  left: -1px;
}

.payAmountBox {
  background-color: #fff;
  height: 92px;
  line-height: 92px;
  .flex();
  align-items: center;
  justify-content: space-between;
}

.label {
  .fontSize(13px);
  color: rgba(51, 51, 51, 1);
}

.payAmount {
  .fontSize(13px);
  color: rgba(252, 63, 86, 1);
}

/*-----------底部模块----------*/

.btnBox {
  height: 108px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 33;
  .borderT();
  background-color: #fff;
  .flex();
  align-items: center;
  justify-content: flex-end;
}

.cancel {
  width: 152px;
  height: 56px;
  box-sizing: border-box;
  border-radius: 4px;
  .border();
  .fontSize(13px);
  color: rgba(102, 102, 102, 1);
  line-height: 56px;
  text-align: center;
  margin-right: 20px;
}

.btn {
  width: 152px;
  height: 56px;
  border-radius: 4px;
  .border(@color17);
  .fontSize(13px);
  color: @color17;
  line-height: 56px;
  text-align: center;
  margin-right: 28px;
}
.QRCodeOrderNo_tips {
  width: 100%;
  height: 60px;
  background: rgba(255, 229, 210, 1);
  text-align: center;
  line-height: 60px;
  font-size: 28px;
  color: rgba(255, 126, 30, 1);
}
.footer_btn{
  position:fixed;
  bottom:0;left:0;right:0;
  height:108px;
  background:#fff;
  padding:0 32px;
  .flex();
  justify-content: space-between;
  align-items:center;
  span{
    display:block;
    line-height:68px;
    box-sizing:border-box;
    font-size:28px;
    width:332px;
    height:68px;
    border-radius:4px;
    text-align: center;
  }
  .btn_left{
    .border(rgba(23,64,218,1));
    background:rgba(243,245,253,1);
    color:rgba(23,64,218,1);
  }
  .btn_right{
    background:rgba(23,64,218,1);
    color:#fff;
  }
}
</style>
